let isTerminalBusy = false;

$(function () {
    const p = $("body").attr("p");

    if (p === 'payment_standby_mode') {
        let tapCount = 0;
        passVerifoneDataToWebView({
            action: 'verifone',
            data: {
            action: 'initialize'
            }
        });

        function toggleStandaloneMode(onOffMode) {
            const terminalId = localStorage.getItem('verifoneSerialNumber') || '';
            const formData = new FormData();
            formData.append('terminal_id', terminalId);
            formData.append('is_standalone_mode_on', onOffMode ? 1 : 0);
            return $.ajax({
                url: '/api/v1/private/terminal/toggle-standalone-mode',
                type: 'POST',
                data: formData,
                enctype: "multipart/form-data",
                async: true,
                cache: false,
                processData: false,
                contentType: false,
                success: function (response) {

                },
                error: function (xhr, status, error) {
                    if (xhr.responseJSON.redirect_url !== undefined && xhr.responseJSON.redirect_url !== null) {
                        document.location.href = xhr.responseJSON.redirect_url;
                    }
                    console.error('Error toggling standalone mode:', error);
                }
            })
        }

        toggleStandaloneMode(1);

        // Payment status functions
        function showPaymentSuccess() {
            const $status = $('#payment-status');
            const $phoneIcon = $('#phoneIcon');
            const $spinner = $('#spinner');
            const $checkmark = $('#checkmark');
            const $xmark = $('#xmark');
            const $title = $('#statusTitle');
            const $subtitle = $('#statusSubtitle');

            // Update UI for success
            $status.addClass('success').removeClass('failed reconnecting lost');
            $phoneIcon.hide();
            $xmark.removeClass('show');
            $checkmark.addClass('show');
            $title.text('Betaling godkjent');
            $subtitle.text('Transaksjonen ble fullført');

            // Reset after 3 seconds
            setTimeout(resetToWaiting, 3000);
        }

        function showPaymentFailed() {
            const $status = $('#payment-status');
            const $phoneIcon = $('#phoneIcon');
            const $spinner = $('#spinner');
            const $checkmark = $('#checkmark');
            const $xmark = $('#xmark');
            const $title = $('#statusTitle');
            const $subtitle = $('#statusSubtitle');
            const $connectionStatus = $('#connectionStatus');
            const $connectionStatusText = $('#connectionStatusText');
            const $retryConnectionButton = $('#retryConnectionButton');

            // Reset UI to waiting state
            $connectionStatus.removeClass('disconnected connecting');
            $connectionStatusText.text('Tilkoblet');
            $retryConnectionButton.addClass('d-none');
            $status.addClass('failed').removeClass('success reconnecting lost processing');
            $spinner.removeClass('show');
            $phoneIcon.hide();
            $checkmark.removeClass('show');
            $xmark.addClass('show');
            $title.text('Betaling mislyktes');
            $subtitle.text('Vennligst prøv igjen');

            // Reset after 3 seconds
            setTimeout(resetToWaiting, 3000);
        }

        function showConnectionLost() {
            const $status = $('#payment-status');
            const $phoneIcon = $('#phoneIcon');
            const $spinner = $('#spinner');
            const $checkmark = $('#checkmark');
            const $xmark = $('#xmark');
            const $title = $('#statusTitle');
            const $subtitle = $('#statusSubtitle');
            const $connectionStatus = $('#connectionStatus');
            const $connectionStatusText = $('#connectionStatusText');
            const $retryConnectionButton = $('#retryConnectionButton');

            // Update UI for connection lost
            $connectionStatus.addClass('disconnected');
            $connectionStatusText.text('Frakoblet');
            $retryConnectionButton.removeClass('d-none');
            $status.addClass('failed').removeClass('success reconnecting processing');
            $spinner.removeClass('show');
            $phoneIcon.hide();
            $checkmark.removeClass('show');
            $xmark.addClass('show');
            $title.text('Tilkobling tapt');
            $subtitle.text('Kunne ikke koble til serveren');

            // Show retry button if container exists
            $('#retryContainer').show();
        }

        function resetToWaiting() {
            const $status = $('#payment-status');
            const $phoneIcon = $('#phoneIcon');
            const $spinner = $('#spinner');
            const $checkmark = $('#checkmark');
            const $xmark = $('#xmark');
            const $title = $('#statusTitle');
            const $subtitle = $('#statusSubtitle');
            const $connectionStatus = $('#connectionStatus');
            const $connectionStatusText = $('#connectionStatusText');
            const $retryConnectionButton = $('#retryConnectionButton');

            // Reset UI to waiting state
            $connectionStatus.removeClass('disconnected connecting');
            $connectionStatusText.text('Tilkoblet');
            $retryConnectionButton.addClass('d-none');
            $status.removeClass('success failed processing');
            $spinner.removeClass('show');
            $checkmark.removeClass('show');
            $xmark.removeClass('show');
            $phoneIcon.show().removeClass('success failed processing');
            $title.text('Venter på betaling');
            $subtitle.text('Klar til å motta betaling');

            // Remove spinner if present
            $('.icon-container .spinner').remove();

            // Hide retry container
            $('#retryContainer').hide();
        }

        // Expose functions globally for testing
        window.showPaymentSuccess = showPaymentSuccess;
        window.showPaymentFailed = showPaymentFailed;
        window.showConnectionLost = showConnectionLost;
        window.resetToWaiting = resetToWaiting;

        let holdTimer;
        const holdDuration = 3000;

        $('#connectionStatus').on('mousedown touchstart', function(e) {
            e.preventDefault();

            $(this).addClass('tapped');

            holdTimer = setTimeout(() => {
                exitStandby();
                $(this).removeClass('tapped');
            }, holdDuration);
        });

        $('#connectionStatus').on('mouseup mouseleave touchend touchcancel', function() {
            if (holdTimer) {
                clearTimeout(holdTimer);
            }
            $(this).removeClass('tapped');
        });

        function exitStandby() {
            $('#exitOverlay').addClass('active');
        }

        $(document).on('submit', "#confirmExitForm", function (e) {
            e.preventDefault();
            const verifoneSerialNumber = localStorage.getItem('verifoneSerialNumber') || '';
            toggleStandaloneMode(0).done(() => {
                window.globalSocket.send(JSON.stringify({
                    type: "verifone",
                    action: "terminal_unavailable",
                    verifoneSerialNumber: verifoneSerialNumber,
                }));
                document.location.href = $("#connectionStatus").attr("href");
            })
        })

        $('#exitOverlay').on('click', function(e) {
            if (e.target === this) {
            $(this).removeClass('active');
            tapCount = 0;
            }
        });

        setInterval(function() {
            $('.status-indicator').css('opacity', '0.5');
            setTimeout(function() {
            $('.status-indicator').css('opacity', '1');
            }, 500);
        }, 2000);

        $('.method-btn').on('click', function() {
            const btn = $(this);
            btn.css('background', '#d1d5db');
            setTimeout(() => {
            btn.css('background', '#f3f4f6');
            }, 150);
        });

        // Retry button handler (add this if #retryBtn exists)
        $(document).on('click', "#retryConnectionButton", function () {
            passVerifoneDataToWebView({
              action: 'verifone',
              data: {
                action: 'initialize'
              }
            });
        });
    }
})